import type { RouteProps } from 'react-router';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import NotFound from 'bundles/phoenix/components/NotFound';

type GetComponent = Required<RouteProps>['getComponent'];

const gateOnUnifiedEnterprise =
  (getComponent: GetComponent): GetComponent =>
  (nextState, cb) => {
    if (!GrowthDiscoveryEpicClient.preview('orgScopedHome')) {
      cb(null, NotFound);
      return;
    }
    getComponent(nextState, cb);
  };

export default gateOnUnifiedEnterprise;
